// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2SgBM","savePackageButton":"ClientWallet_savePackageButton__1wdJo"};